import { isMandatory } from "../enums/category.enum";
import { Status } from "../enums/status.enum";
var CookieComponent = /** @class */ (function () {
    function CookieComponent(cookieData) {
        this.cookie = cookieData;
        this.render();
        this.listeners();
    }
    CookieComponent.prototype.listeners = function () {
        var _this = this;
        if (this.checkbox) {
            this.checkbox.addEventListener('change', function () {
                // @ts-ignore
                _this.cookie.status = _this.checkbox.checked ? Status.ACCEPTED : Status.REFUSED;
            });
        }
    };
    CookieComponent.prototype.render = function () {
        var _a;
        var _b = this.cookie, category = _b.category, initialStatus = _b.initialStatus;
        this.component = document.createElement('div');
        this.component.classList.add("cookies-made-simple-cookie");
        this.component.append(this.renderHeader());
        if (!isMandatory(category)) {
            var checkbox = (_a = this.component) === null || _a === void 0 ? void 0 : _a.querySelector('input[type=checkbox]');
            if (checkbox instanceof HTMLInputElement) {
                this.checkbox = checkbox;
                var isRefused = initialStatus !== undefined && initialStatus !== Status.REFUSED;
                this.checkbox.checked = isRefused;
            }
            else {
                console.error("CMS: Unexpected query didn't return HTMLInputElement");
            }
        }
        return this.component;
    };
    CookieComponent.prototype.renderHeader = function () {
        var _a = this.cookie, title = _a.title, category = _a.category;
        var cookieHeaderElement = document.createElement('div');
        cookieHeaderElement.classList.add("cookies-made-simple-cookie-header");
        var componentHtml = '<div class="cookie-header-title">';
        componentHtml += "<div class=\"cookie-title\">".concat(title, "</div></div>");
        if (!isMandatory(category)) {
            componentHtml += "\n        <div class=\"cookie-switch\">\n          <label class=\"switch\">\n            <input type=\"checkbox\" checked>\n            <span class=\"slider\"></span>\n          </label>\n        </div>\n      ";
        }
        cookieHeaderElement.innerHTML = componentHtml;
        return cookieHeaderElement;
    };
    CookieComponent.prototype.renderContent = function () {
        /**
         * This code used to generated the individual cookie description when activated.
         * As cookies are global scoped and only loaded if used, having each cookie a description with internationalization is
         * a challenge and isn't needed as first version.
         * */
        // const { description } = this.cookie;
        var cookieContentElement = document.createElement('div');
        cookieContentElement.classList.add("cms-cookie-content");
        // var componentHtml = `${this.properties.showCookieDescription ? '<div class="cookie-description">' + description + '</div>' : ''}`;
        var componentHtml = '';
        cookieContentElement.innerHTML = componentHtml;
        return cookieContentElement;
    };
    CookieComponent.prototype.getState = function () {
        var _a;
        return (_a = this.checkbox) === null || _a === void 0 ? void 0 : _a.checked;
    };
    CookieComponent.prototype.setState = function (state) {
        if (this.checkbox) {
            this.checkbox.checked = state;
        }
    };
    return CookieComponent;
}());
export default CookieComponent;
